module.exports = __webpack_public_path__ + "static/media/waxhead.2ab45cce.jpg";